module.exports = __webpack_public_path__ + "img/addressEle.839213db.svg";